import { render } from "./scoreboard.vue?vue&type=template&id=64897b8c&scoped=true"
import script from "./scoreboard.vue?vue&type=script&lang=js"
export * from "./scoreboard.vue?vue&type=script&lang=js"

import "./scoreboard.vue?vue&type=style&index=0&id=64897b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64897b8c"]])

export default __exports__